import { render, staticRenderFns } from "./TestMarkingForm.vue?vue&type=template&id=7152f9c4"
import script from "./TestMarkingForm.vue?vue&type=script&lang=js"
export * from "./TestMarkingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports